<div class="timeline-buttons hide-on-recording hide-on-playback">
  <div class="timeline-buttons__group">
    <button
      class="timeline-buttons__button"
      (click)="onStartButtonClick()"
      [disabled]="startButtonIsDisabled"
      title="Go to the beginning of the record"
      i18n-title
    >
      <span class="icon-start"></span>
    </button>

    <button
      class="timeline-buttons__button"
      (click)="onBackwardButtonClick()"
      [disabled]="backwardButtonIsDisabled"
      title="Move back a bit"
      i18n-title
    >
      <span class="icon-backward"></span>
    </button>

    <button
      class="timeline-buttons__button"
      (click)="onForwardButtonClick()"
      title="Move a little forward"
      i18n-title
    >
      <span class="icon-forward"></span>
    </button>

    <button
      class="timeline-buttons__button"
      (click)="onEndButtonClick()"
      [disabled]="endButtonIsDisabled"
      title="Go to the end of the record"
      i18n-title
    >
      <span class="icon-end"></span>
    </button>
  </div>

  <div class="timeline-buttons__group">
    <button
      class="timeline-buttons__button"
      (click)="onZoomOutButtonClick()"
      [disabled]="outButtonIsDisabled"
      title="Zoom out"
      i18n-title
    >
      <span class="icon-zoom-out"></span>
    </button>

    <button
      class="timeline-buttons__button"
      (click)="onZoomInButtonClick()"
      [disabled]="inButtonIsDisabled"
      title="Zoom in"
      i18n-title
    >
      <span class="icon-zoom-in"></span>
    </button>
  </div>
</div>



// WEBPACK FOOTER //
// ./src/app/rec/timeline/timeline-buttons/timeline-buttons.component.html